import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

function LayoutFooter() {
  return (
    <Footer className='app-layout-footer'>
      The Stranger Things ©2020 Created by Vadim Melnikov
    </Footer>
  );
}

export default LayoutFooter;
